import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init, browserTracingIntegration } from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const initSentry = (): void => {
  init({
    dsn: 'https://0087b96217f6040897e07482f399e743@sentry.ooo.technology/53',
    integrations: [browserTracingIntegration()],
    environment:
      (environment.production ? 'prod_' : 'dev_') + environment.envType,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enabled:
      !location.hostname.match('127.0.0.1') &&
      !location.hostname.match('localhost'),
  });
};

initSentry();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
